import React from "react";

function RightIcon(props) {
  return (
    <svg
      viewBox="0 0 512.00 512.00"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={props.width || 18}
      height={props.height || 18}
      //   viewBox="0 0 256 256"
      fill={props.color || "#77b771"}
    >
      <path d="M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"></path>
    </svg>
  );
}

export default RightIcon;
